require("./bringoz-notes-list.scss");

import {ChangeDetectionStrategy, Component, input} from "@angular/core";

export interface NoteAttachment {
  name?: string;
  url?: string;
  mimeType?: string;
}

export interface Note {
  id?: string;
  createdAt?: number;
  creator?: {name?: string};
  noteType?: string;
  title?: string;
  text?: string;
  attachments?: NoteAttachment[];
}

@Component({
  selector: "app-bringoz-notes-list",
  templateUrl: "./bringoz-notes-list.html",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BringozNotesListComponent {
  readonly notes = input<Note[]>([]);
}
